import { createAction } from 'redux-actions';

export const setSchoolNames = createAction('SET_SCHOOL_NAMES');
export const setLoadingSchoolNames = createAction('SET_LOADING_SCHOOL_NAMES');
// saga
export const SAGA_GET_SCHOOL_NAMES = 'SAGA_GET_SCHOOL_NAMES';
